import { useMemo, type ReactNode } from 'react';
import { InlineFormattedNumberContext } from '../FormattedNumber/InlineFormattedNumberContext';
import type { BlotterTableSettings } from './BlotterTableContext';
import { useBlotterTableContext } from './BlotterTableContext';

interface BlotterTableFormattedNumberProviderProps {
  settings?: BlotterTableSettings;
  children: ReactNode;
}

export function BlotterTableFormattedNumberProvider({ settings, children }: BlotterTableFormattedNumberProviderProps) {
  const blotterTableContext = useBlotterTableContext();
  const globalShowAllDecimals = blotterTableContext.settings?.showAllDecimals ?? false;
  const localShowAllDecimals = settings?.showAllDecimals;
  const showAllDecimals = Boolean(globalShowAllDecimals || localShowAllDecimals);

  const inlineFormattedNumberContextValue = useMemo(() => ({ showAllDecimals }), [showAllDecimals]);

  return (
    <InlineFormattedNumberContext.Provider value={inlineFormattedNumberContextValue}>
      {children}
    </InlineFormattedNumberContext.Provider>
  );
}
